import { elemSiblings } from './functions/support';
import './slick/slick';
import './lightgallery/lightgallery';

const $ = require('jquery');

const INIT_storageUnits = () => {
    $(".js-storage-units").slick({
        adaptiveHeight: true,
        arrows: false,
        dots: false,
        draggable: false,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        touchMove: false,
        initialSlide: $(".js-storage-toggle.is-active").index(".js-storage-toggle"),
    });

    $(".js-storage-toggle").click((e) => {
        var index = e.target.dataset.index;
        $(".js-storage-units").slick("slickGoTo", index);
    });

    $(".js-storage-units").on(
        "beforeChange",
        (e, slick, currentSlide, nextSlide) => {
            $(".js-storage-toggle").removeClass("is-active");
            $(".js-storage-toggle").eq(nextSlide).addClass("is-active");
            $(".js-storage-units .slick-active [data-type]").removeClass("is-active");
        }
    );

    $(".js-storage-units").on(
        "afterChange",
        (e, slick, currentSlide) => {
        $(".js-storage-usage-select").eq(currentSlide).change();
        }
    );

    window.addEventListener('click', (event) => {
        const target = event.target;

        if (target.dataset.storageUnitSelect && target.dataset.storageUnitSelectValue) {
            target.blur();
            target.parentElement.classList.add('is-active');

            const targetSiblings = elemSiblings(target.parentElement);

            if (targetSiblings.length) {
                targetSiblings.forEach(sibling => {
                    sibling.classList.remove('is-active');
                });
            }

            const $select = $(`#${target.dataset.storageUnitSelect}`);

            $select.val(target.dataset.storageUnitSelectValue);
            $select.change();
        }
    });

    $(".js-storage-usage-select").change(function () {
        var value = $(this).val();
        var $this = $(this);
        var index = $this.index(".js-storage-usage-select");
        var $rooms = $('.js-storage-units [data-slick-index="' + index + '"] .js-storage-room-contents[data-type]');
        var $activeRoom = $rooms.filter(".is-active");
        var $newRoom = $rooms.filter('[data-type="' + value + '"]');

        if ($activeRoom.is($newRoom)) {
            return;
        }

        if (!$activeRoom.length) {
            $newRoom.removeClass("is-exiting");
            $newRoom.addClass("is-active");
        } else {
            $activeRoom.removeClass("is-active");
            $activeRoom.addClass("is-exiting");

            $activeRoom.find("img:first-child").one("transitionend", () => {
                $activeRoom.removeClass("is-exiting");
                $this.change();
            });
        }
    });

    $(".slick-active .js-storage-usage-select").change();

    $(".js-lightbox-gallery").each(function () {
        lightGallery(this, {
            download: false,
            counter: false,
            selector: "a",
        });
    });

    $(".js-slick-slider").slick({
        arrows: true,
        dots: true,
    });

    $(".js-slick-slider").on("beforeChange", (e) => {
        e.stopPropagation();
    });
};

$(document).ready(() => {
    INIT_storageUnits();
});
